<!--
 * @Description: 对账联系函
 * @Autor: txp
 * @Date: 2021-05-07 11:28:36
-->
<template>
  <div class="reconciliation">
    <el-card class="box-card">
      <div class="mtb20 ft12 C787878">
        <span>服务中心：</span>
        <span>
          <a href="#" class="text-decoration_none themColor" @click="goHomes">返回上一页</a>
        </span>
        <span class="el-icon-arrow-right"></span>
        <span>对账函</span>
      </div>
      <div class="text item reconciliation_content">
        <div>
          <h2 class="textcenter">对账联系函</h2>
          <p class="ft16 D1D1D1 font_weight mt10">致：{{ customerInfo.customerName }}</p>
          <p class="ft16 D1D1D1 font_weight mt10">尊敬的客户：</p>
          <p class="ft16 D1D1D1 font_weight mt10 text-indent2">您好</p>
        </div>
        <div class="mt10 lineheight30">
          <div class="text-indent2">
            <p>
              感谢贵公司就双方合作以来提供的大力支持与配合，我公司正在开展本期的对账工作，需贵公司协助确认本函件中账单信息所列内容。
            </p>
            <p></p>
            <p>
              请贵公司在收到此对账单后5个工作日内，在恒大冰泉DMS经销商商城进行核对，对账单确认无误的，请点击确认并下载附件中的“对账函”进行盖章，同时将盖章的纸质原件邮寄至：深圳市福田区凯丰路10号翠林中心大厦27楼财务中心，收件人：刘丽，联系电话：0755-33985966转82326。对账单信息存在异议的，请在恒大冰泉DMS经销商商城进行反馈，超过5个工作日未反馈且未盖章回传的，自动视为对该账单无异议。
            </p>
          </div>
          <div class="letterInfo">
            <div>
              <p>客户信息</p>
              <div class="letterInfo_info">
                <div>客户编码：{{ customerInfo.customerCode }}</div>
                <div>销售公司：{{ customerInfo.saleOrg }}</div>
                <div>客户名称：{{ customerInfo.customerName }}</div>
                <div>对账期间：{{ customerInfo.startTime }}~{{ customerInfo.endTime }}</div>
              </div>
              <div class="letterInfo_conts">
                <p>往来情况</p>
                <p>
                  为了维护双方的合作关系，充分体现客户对其经营情况的知情权，避免非本司行为造成客户的损失，特做以下确认。
                </p>
                <div class="letterInfo_cont">
                  <p>（一）本期发货总额</p>
                  <p>{{ customerInfo.sendAmount || 0 }}元</p>
                  <p>详见发货明细</p>
                </div>
                <div class="letterInfo_cont">
                  <p>（二）本期收款总额（现金回款+保证金转货款）</p>
                  <p>{{ customerInfo.receiveAmount || 0 }}元</p>
                  <p>详见收款明细</p>
                </div>
                <div class="letterInfo_cont">
                  <p>（三）本期核销费用情况（已核销费用-已使用费用）</p>
                  <p>{{ customerInfo.auditCost || 0 }}元</p>
                  <p>详见核销费用明细</p>
                </div>
                <div>
                  <p>（四）截至{{ customerInfo.endTime || 0 }}，贵司在我司账余情况如下：</p>
                  <div class="letterInfo_cont">
                    <p>A.保证金余额：</p>
                    <p>{{ customerInfo.bzjBalance || 0 }}元</p>
                  </div>
                  <div class="letterInfo_cont">
                    <p>B.预收款余额：</p>
                    <p>{{ customerInfo.advancePayment || 0 }}元</p>
                  </div>
                  <div class="letterInfo_cont">
                    <p>C.已下单未出货金额：</p>
                    <p>{{ customerInfo.notOutGoods || 0 }}元</p>
                  </div>
                  <div class="letterInfo_cont">
                    <p>D.已发货未开票金额：</p>
                    <p>{{ customerInfo.notInvoicing || 0 }}元</p>
                  </div>
                  <div class="letterInfo_cont">
                    <p>E.实际可用账户余额（E=B-C-D）：</p>
                    <p>{{ customerInfo.actualAccountBalance || 0 }}元</p>
                  </div>
                  <div class="letterInfo_cont">
                    <p>F.返利余额：</p>
                    <p>{{ customerInfo.rebateBalance || 0 }}元</p>
                  </div>
                  <div class="letterInfo_cont">
                    <p>G.货补-现金垫付余额：</p>
                    <p>{{ customerInfo.cashAdvanceBalance || 0 }}元</p>
                  </div>
                  <div class="letterInfo_cont">
                    <p>H.货补-产品垫付余额：</p>
                    <p>{{ customerInfo.productAdvanceBalance || 0 }}元</p>
                  </div>
                  <div class="letterInfo_cont">
                    <p>I.实际可用下单余额（I=E+F+G+H）：</p>
                    <p>{{ customerInfo.actualOrderBalance || 0 }}元</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p>特别提示：</p>
              <!-- <p>
                为了维护双方的合作关系，充分体现客户对其经营情况的知情权，避免非本司行为造成客户的损失，待做以下确认函。
              </p> -->
              <div>
                <p>
                  1.以上对账单第（三）项的已使用费用表示已下单的费用及其他扣减费用。
                </p>
                <p>
                  2.以上对账单第（四）项中的产品垫付余额，仅为计算发货数量使用，如需转为货款或关户退款，应按经销商代垫产品的实际价值或实际代垫金额重新计算。
                </p>
                <!-- <p>
                  3.客户在收到此账单后5日内必须进行确认，无异议则盖章回传，有异议则第一时间反馈至hdypfd.com邮箱，超过5个工作日未反馈且未盖章回传的，自动视为对该账单无异议。
                </p> -->
                <p>
                  3.客户应于活动结束后30个工作日内向我司提出核销费用申请，如客户在活动结束后30个工作日未提交完整合格的核销资料，直接视同放弃该笔费用，后期不再进行核销。
                </p>
              </div>
            </div>
            <div class="mtb20 textright">
              <el-link
                type="primary"
                @click="exportDetailBtn(1)"
                class="down-link"
                :underline="false"
              >
                下载对账函.pdf
              </el-link>
              <el-link
                type="primary"
                @click="exportDetailBtn(2)"
                class="down-link"
                :underline="false"
              >
                下载发货明细.xlsx
              </el-link>
              <el-link
                type="primary"
                @click="exportDetailBtn(3)"
                class="down-link"
                :underline="false"
              >
                下载收款明细.xlsx
              </el-link>
              <el-link
                type="primary"
                @click="exportDetailBtn(4)"
                class="down-link"
                :underline="false"
              >
                下载核销费用明细.xlsx
              </el-link>
              <!-- <el-button
                @click="exportDetailBtn(1)"
                type="primary"
                :loading="loading"
                >下载对账函.pdf</el-button
              >
              <el-button
                @click="exportDetailBtn(2)"
                type="primary"
                :loading="loading"
                >下载发货明细.xlsx</el-button
              >
              <el-button
                @click="exportDetailBtn(3)"
                type="primary"
                :loading="loading"
                >下载收款明细.xlsx</el-button
              >
              <el-button
                @click="exportDetailBtn(4)"
                type="primary"
                :loading="loading"
                >下载核销费用明细.xlsx</el-button
              > -->
            </div>
          </div>
        </div>
      </div>
      <div class="mtb30 textcenter lineheight40">
        <p>
          <el-button
            v-if="customerInfo.customerStatementStatus === '1'"
            @click="comifInfo(1)"
            type="primary"
          >
            确认对账信息无误
          </el-button>
          <el-button v-else disabled plain>{{ customerInfo.customerStatement }}</el-button>
        </p>
        <p
          class="C787878 ft14 text-decoration_top"
          @click="comifInfo(2)"
          v-if="customerInfo.customerStatementStatus === '1'"
        >
          对账单有疑问？
        </p>
        <p class="C787878 ft14" v-else>您已经提交反馈</p>
      </div>
    </el-card>
    <div v-if="visible">
      <CustormletterDia
        :titles="title"
        :statementCode="customerInfo.statementCode"
        :phoneNum="customerInfo.customerContact"
        :visible.sync="visible"
        @updateVisible="updateVisible"
        @submitPopupData="submitPopupData"
        @handleClose="handleClose"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex' //主题的引用
import {
  CustomerStatementControllerQuery,
  // ExportDetail,
  DownloadExcelFile,
  getPhoneNumber,
  ExportDeliverGoodsDetail,
  ExportReceivePaymentDetail,
  ExportAuditCostDetail
} from '@/api/customer'
import { mdmdictdata } from '@/api/api'
import CustormletterDia from './components/CustormletterDia'

export default {
  name: 'reconciliation',
  data() {
    return {
      visible: false,
      customerFeedback: 'hahah', //反馈信息填入内容
      statementId: '',
      title: '',
      customerInfo: {},
      selectValList: [], //数据字典
      hrefUrlName: '',
      hrefUrl: '',
      loading: false,
      statementCode: '',
      id: ''
    }
  },
  computed: {
    ...mapGetters({
      theme: 'theme'
    })
  },
  components: {
    CustormletterDia
  },
  mounted() {
    const statementCode = this.$route.query.statementCode
    this.statementCode = statementCode
    this.id = this.$route.query.id
    this.controllerListDet(statementCode)
  },
  methods: {
    // 获取数据字典
    async mdmdictdatas() {
      await mdmdictdata({
        dictTypeCode: 'dms_hd_customer_statement_status'
      }).then((res) => {
        if (res.code == 200) {
          this.selectValList = res.result
        }
      })
    },
    // 获取对账函列表详情
    controllerListDet(statementCode) {
      let params = { statementCode: statementCode.trim() }
      CustomerStatementControllerQuery({ ...params }).then(async (res) => {
        await this.mdmdictdatas()
        this.customerInfo = res.result
        this.customerInfo.customerStatement = this.selectValList.find(
          (it) => it.dictCode === res.result.customerStatementStatus
        ).dictValue
        this.customerInfo = JSON.parse(JSON.stringify(this.customerInfo))
      })
    },
    // 确认对账函 / 对账单有疑问
    comifInfo(num) {
      if (num == 1) {
        getPhoneNumber({ statementCode: this.customerInfo.statementCode }).then((res) => {
          if (res.result.customerContact) {
            this.title = '确认对账信息'
            this.customerInfo.customerContact = res.result.customerContact
            this.visible = true
          } else {
            this.$message.error('手机号码不存在，请联系管理员')
          }
        })
      } else {
        this.visible = true
        this.title = '信息反馈'
      }
    },
    // 导出对账明明
    exportDetailBtn(e) {
      let Fn = null
      switch (e) {
        case 1:
          window.location.href = `/dms/dmsHdCustomerStatementController/downloadStatementPdf?statementCode=${this.statementCode}`
          break
        case 2:
          Fn = ExportDeliverGoodsDetail
          break
        case 3:
          Fn = ExportReceivePaymentDetail
          break
        default:
          Fn = ExportAuditCostDetail
          break
      }

      if (Fn) {
        this.loading = true
        Fn({ statementCode: this.statementCode })
          .then((res) => {
            this.loading = false
            DownloadExcelFile({
              objectName: JSON.parse(res.result).result[0].objectName,
              fileName: JSON.parse(res.result).result[0].fileName
            }).then((res) => {
              console.log(res)
            })
          })
          .catch((err) => {
            this.loading = false
          })
      }
    },
    // 返回上一页
    goHomes() {
      window.history.back()
    },
    // 监听弹框得变化
    updateVisible(val) {
      this.visible = val
    },
    handleClose(val) {
      this.visible = val
    },
    submitPopupData(val) {
      this.controllerListDet(this.statementCode)
      this.visible = val
    }
  }
}
</script>
<style lang="scss" scoped>
.reconciliation {
  height: 100%;
  /deep/.el-card {
    height: 100%;
    .letterInfo {
      padding: 20px;
      border: 1px solid #d8d8d8;
      .letterInfo_info {
        display: flex;
        flex-wrap: wrap;
        // margin: 10px 0px;
        color: #333;
        div {
          width: 50%;
          line-height: 30px;
        }
      }
      .letterInfo_conts {
        .letterInfo_cont {
          display: flex;
          flex-wrap: wrap;
          p {
            width: 30%;
          }
          :first-child {
            width: 40%;
          }
        }
      }
    }
  }

  .down-link {
    margin-right: 10px;
  }
}
</style>
